import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import api from './api';

// Componentes modulares
import Login from './components/Login';
import CalendarView from './components/CalendarView';
import PersonalData from './components/PersonalData';
import RoleManagement from './components/RoleManagement';
import ChangePassword from './components/ChangePassword';
import ResetPassword from './components/ResetPassword';

function App() {
  const [isAuth, setAuth] = useState(() => {
    const hash = window.location.hash;
    if (hash && hash.includes('token=')) {
      const params = new URLSearchParams(hash.substring(1));
      const token = params.get('token');
      const role = params.get('role');
      if (token && token.length > 20) {
        sessionStorage.setItem('token', token);
        if (role) sessionStorage.setItem('userRole', role);
        return true;
      }
    }
    const token = sessionStorage.getItem('token');
    return token && token !== 'undefined' && token !== 'null' && token.length > 20;
  });

  const [userRole, setUserRole] = React.useState(() => {
    const saved = sessionStorage.getItem('userRole');
    if (!saved || saved === 'null' || saved === 'undefined') return '';
    return saved.trim();
  });
  const [impersonatedRole, setImpersonatedRole] = React.useState('');
  const [mustChange, setMustChange] = React.useState(sessionStorage.getItem('must_change') === 'true');
  const [showActions, setShowActions] = React.useState(false);
  const [showPersonalData, setShowPersonalData] = React.useState(false);

  useEffect(() => {
    const hash = window.location.hash;
    if (hash && hash.includes('token=')) {
      window.history.replaceState(null, '', window.location.pathname);
    }
  }, []);

  useEffect(() => {
    if (isAuth) {
      // Sync immediately from sessionStorage (set by Login.jsx before setAuth(true))
      // so menu items appear without waiting for the async profile fetch
      const saved = sessionStorage.getItem('userRole');
      if (saved && saved !== 'null' && saved !== 'undefined') {
        setUserRole(saved.trim());
      }

      const fetchUserData = async () => {
        try {
          const res = await api.get('users/profile/');
          const user = res.data;

          const role = (user.role || '').trim();
          const validRoles = ['CG', 'ACG', 'CO', 'ACO', 'CD', 'RM', 'CA', 'DO', 'AL'];
          const impersonated = validRoles.includes((user.impersonated_role || '').trim())
            ? user.impersonated_role.trim()
            : '';

          setUserRole(role);
          setImpersonatedRole(impersonated);
          sessionStorage.setItem('userRole', role);
          sessionStorage.setItem('userEmail', user.email);
        } catch (err) {
          console.error("App: Error fetching user data:", err);
          if (err.response && err.response.status === 401) {
            setAuth(false);
          }
        }
      };
      fetchUserData();
    }
  }, [isAuth]);

  const toggleActions = () => {
    setShowActions(!showActions);
  };

  const openPersonalData = () => {
    setShowPersonalData(true);
    setShowActions(false);
  };

  const handlePasswordSuccess = () => {
    sessionStorage.removeItem('must_change');
    setMustChange(false);
  };

  if (isAuth && mustChange) {
      return <ChangePassword onSuccess={handlePasswordSuccess} />;
  }

  return (
    <Router>
      <div className="app-container" translate="no">
        <div className="content-wrapper">
          <Routes>
            <Route path="/login" element={!isAuth ? <Login setAuth={setAuth} /> : <Navigate to="/" />} />
            <Route path="/reset-password/:uid/:token/*" element={<ResetPassword />} />
            <Route path="/password-reset-confirm/:uid/:token/*" element={<ResetPassword />} />
            <Route path="/roles" element={isAuth ? <RoleManagement /> : <Navigate to="/login" />} />
            <Route path="/" element={isAuth ? (
                <>
                <CalendarView 
                  impersonatedRole={impersonatedRole}
                  setImpersonatedRole={setImpersonatedRole}
                  userRole={userRole}
                  showActions={showActions}
                  toggleActions={toggleActions}
                  openActionsMenu={openPersonalData}
                />
                {showPersonalData && <PersonalData onClose={() => setShowPersonalData(false)} />}
                </>
            ) : <Navigate to="/login" />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
